import {
    getAnnouncements,
    deleteAnnouncement,
    createAnnouncement,
    updateAnnouncement,
    getSingleAnnouncement,
} from "../../api/announcement";
import { toArray, toObject } from "../../utils/languageContent";
import { getPersistenceData, setPersistenceData } from "../../utils/persistenceStorage";

const announcement = {
    namespaced: true,
    state: {
        announcements: {
            total: 0,
            count: 0,
            data: [],
        },
        readAnnouncements: getPersistenceData("announcements", []),
    },
    getters: {
        unreadAnnouncements: (state) => {
            return (
                state.announcements.data.some((announcement) => !state.readAnnouncements.includes(announcement._id)) &&
                !!state.announcements.data.length
            );
        },
    },
    mutations: {
        SET_ANNOUNCEMENTS: (state, payload) => {
            state.announcements = payload;
        },
        SET_READ_ANNOUNCEMENTS: (state, payload) => {
            state.readAnnouncements = payload;
        },
        ADD_ANNOUNCEMENT: (state, payload) => {
            state.announcements.data.push(payload);
            state.announcements.total++;
        },
        UPDATE_ANNOUNCEMENT: (state, payload) => {
            let announcements = state.announcements.data.findIndex((p) => p._id === payload._id);
            announcements = payload;
        },
        REMOVE_ANNOUNCEMENT: (state, id) => {
            state.announcements.data = state.announcements.data.filter((u) => u._id !== id);
            state.announcements.total--;
        },
    },
    actions: {
        getLastAnnouncements({ commit }, payload) {
            return getAnnouncements(10, 0, true).then((response) => {
                const total = response.data.total;
                const count = response.data.count;
                const data = response.data.data.map((x) => toObject(x));
                commit("SET_ANNOUNCEMENTS", { data, count, total });
            });
        },
        getAnnouncements({ commit }, payload) {
            return getAnnouncements(payload.perPage, payload.page).then((response) => {
                const total = response.data.total;
                const count = response.data.count;
                const data = response.data.data.map((x) => toObject(x));
                commit("SET_ANNOUNCEMENTS", { data, count, total });

                if (payload.perPage < 0) {
                    return data;
                }
            });
        },
        getAnnouncement({ state }, id) {
            const maybeAnn = state.announcements.data.find((u) => u._id === id);
            return (
                maybeAnn ||
                getSingleAnnouncement(id).then(({ data }) => {
                    return data.map((x) => toObject(x));
                })
            );
        },
        createAnnouncement({ commit }, payload) {
            return createAnnouncement(toArray(payload)).then((response) => {
                const data = toObject(response.data);
                commit("ADD_ANNOUNCEMENT", data);
                return Promise.resolve(data);
            });
        },
        updateAnnouncement({ commit }, payload) {
            return updateAnnouncement(payload._id, toArray(payload)).then((response) => {
                const data = toObject(response.data);
                commit("UPDATE_ANNOUNCEMENT", data);
                return Promise.resolve(data);
            });
        },
        deleteAnnouncement({ commit }, id) {
            commit("REMOVE_ANNOUNCEMENT", id);
            return deleteAnnouncement(id);
        },
        setReadAnnouncement({ commit, state }) {
            const payload = state.announcements.data.map((x) => x._id);
            commit("SET_READ_ANNOUNCEMENTS", payload);
            setPersistenceData("announcements", payload, true);
        },
    },
};

export default announcement;
